module.exports = "<span class=\"pf-nav_item\">\n  <span>{{ itemName }}</span>\n</span>"